import { ApplicationConfig, provideZoneChangeDetection, isDevMode, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { TokenInterceptor } from './core/interceptor/token.interceptor';
import { FingerprintjsProAngularModule } from '@fingerprintjs/fingerprintjs-pro-angular';
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideStore } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { metaReducers, reducers } from './store';
import { rootEffects } from './store/root.effect';
import { provideServiceWorker } from '@angular/service-worker';
import { environment } from '../environments/environment';


export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimationsAsync(),
    provideHttpClient(
      withFetch(),
      withInterceptorsFromDi(),
    ),
    provideStore(reducers, { metaReducers }),
    provideEffects(rootEffects),
    provideStoreDevtools({
      maxAge: 25,
      logOnly: !isDevMode(), 
      autoPause: true,
      trace: false,
      traceLimit: 75,
    }),
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    provideServiceWorker('ngsw-worker.js', {
      enabled: environment.production
    }),
    importProvidersFrom(
      [ FingerprintjsProAngularModule.forRoot({
        loadOptions: {
          apiKey: "ZNcV1vVkyZX7kHbYd2p6",
          endpoint: [
            "https://fp.opinion-edge.com"
          ],
          scriptUrlPattern: [
            "https://fp.opinion-edge.com/web/v3/ZNcV1vVkyZX7kHbYd2p6/loader_v3.9.3.js"
          ]
        }
      }),
        TranslateModule.forRoot({
          loader: {
            provide: TranslateLoader,
            useFactory: HttpLoaderFactory,
            deps: [HttpClient],
          },
        })
      ]
    )
    
  ]
};


